import React from 'react';
import '@/App.css';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import { Toaster } from '@/components/ui/sonner';
// import Landing from './pages/Landing';
// import UploadCV from './pages/UploadCV';
// import JobDescription from './pages/JobDescription';
// import Results from './pages/Results';
import Portfolio from './components/portfolio/Portfolio';


function App() {
  return (
    <div className="App">
      <Portfolio />
      {/* <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/upload" element={<UploadCV />} />
          <Route path="/job-description" element={<JobDescription />} />
          <Route path="/results" element={<Results />} />
        </Routes>
      </BrowserRouter> */}
    </div>
  );
}

export default App;
